const MESSAGE_GLOBAL_COOLDOWN_MS = 20_000;
const MESSAGE_CONVERSATION_COOLDOWN_MS = 60_000;
const ACTIVE_CHAT_RECENT_INTERACTION_MS = 60_000;
const NOTIFICATION_COOLDOWN_MS = 120_000;
class NotificationSoundService {
    audio = new Map();
    enabled = false;
    lastMessagePlayedAt = 0;
    lastMessageByConversation = new Map();
    lastNotificationPlayedAt = 0;
    playSequence = new Map();
    enableAfterUserGesture() {
        if (this.enabled)
            return;
        this.enabled = true;
        this.preload("message");
        this.preload("notification");
        this.unlock("message");
        this.unlock("notification");
    }
    playMessageIfAllowed(context) {
        const now = context.now ?? Date.now();
        const changedConversationId = context.changedConversationId ?? null;
        if (context.isTenantAdmin === false)
            return false;
        if (!this.canPlayBase(context.previousUnreadCount, context.nextUnreadCount)) {
            return false;
        }
        if (now - this.lastMessagePlayedAt < MESSAGE_GLOBAL_COOLDOWN_MS) {
            return false;
        }
        if (changedConversationId) {
            const lastConversationPlay = this.lastMessageByConversation.get(changedConversationId) ?? 0;
            if (now - lastConversationPlay <
                MESSAGE_CONVERSATION_COOLDOWN_MS) {
                return false;
            }
        }
        if (this.isRecentActiveConversationInteraction(context, now)) {
            return false;
        }
        this.lastMessagePlayedAt = now;
        if (changedConversationId) {
            this.lastMessageByConversation.set(changedConversationId, now);
        }
        this.play("message");
        return true;
    }
    playNotificationIfAllowed(context) {
        const now = context.now ?? Date.now();
        if (context.isTenantAdmin === false)
            return false;
        if (!this.canPlayBase(context.previousUnreadCount, context.nextUnreadCount)) {
            return false;
        }
        if (this.isNotificationCenterPath(context.currentPath)) {
            return false;
        }
        if (now - this.lastNotificationPlayedAt < NOTIFICATION_COOLDOWN_MS) {
            return false;
        }
        this.lastNotificationPlayedAt = now;
        this.play("notification");
        return true;
    }
    resetForTests() {
        this.audio.clear();
        this.enabled = false;
        this.lastMessagePlayedAt = 0;
        this.lastMessageByConversation.clear();
        this.lastNotificationPlayedAt = 0;
        this.playSequence.clear();
    }
    canPlayBase(previous, next) {
        return this.enabled && next > previous;
    }
    isRecentActiveConversationInteraction(context, now) {
        const activeConversationId = context.activeConversationId ?? null;
        const changedConversationId = context.changedConversationId ?? null;
        if (!activeConversationId || !changedConversationId)
            return false;
        if (activeConversationId !== changedConversationId)
            return false;
        const documentHasFocus = context.documentHasFocus ??
            (typeof document !== "undefined" ? document.hasFocus() : true);
        if (!documentHasFocus)
            return false;
        const lastChatInteractionAt = context.lastChatInteractionAt ?? 0;
        return (lastChatInteractionAt > 0 &&
            now - lastChatInteractionAt <= ACTIVE_CHAT_RECENT_INTERACTION_MS);
    }
    isNotificationCenterPath(path) {
        const currentPath = path ?? (typeof window !== "undefined" ? window.location.pathname : "");
        return currentPath.startsWith("/admin/notifications");
    }
    preload(kind) {
        const audio = this.getAudio(kind);
        audio.preload = "auto";
        audio.load();
    }
    play(kind) {
        const audio = this.getAudio(kind);
        this.playSequence.set(kind, (this.playSequence.get(kind) ?? 0) + 1);
        audio.muted = false;
        audio.currentTime = 0;
        audio.play().catch(() => {
            // Browser autoplay policies can still block playback; ignore safely.
        });
    }
    unlock(kind) {
        const audio = this.getAudio(kind);
        const sequenceAtUnlock = this.playSequence.get(kind) ?? 0;
        audio.muted = true;
        audio.currentTime = 0;
        audio
            .play()
            .then(() => {
            if ((this.playSequence.get(kind) ?? 0) === sequenceAtUnlock) {
                audio.pause();
                audio.currentTime = 0;
            }
            audio.muted = false;
        })
            .catch(() => {
            audio.muted = false;
        });
    }
    getAudio(kind) {
        const existing = this.audio.get(kind);
        if (existing)
            return existing;
        const audio = new Audio(`/sounds/${kind}.mp3`);
        audio.volume = 0.5;
        this.audio.set(kind, audio);
        return audio;
    }
}
export const notificationSoundService = new NotificationSoundService();
